import { getGlobal, setGlobal } from 'reactn';
import Net from '../lib/Net';

export async function fetchArchivosCompartidos(){
    var data = await Net.get('/archivos-grupos');
    setGlobal({ archivosCompartidos: data });
}